import { useCallback, useEffect, useState } from 'react';
import {
  enableWebPush,
  getPushStatus,
  isWebPushSupported,
  markPushPromptSeen,
  shouldShowPushPrompt,
} from '../push/webPush';

export function usePushNotifications() {
  const [status, setStatus] = useState(
    isWebPushSupported() ? 'default' : 'unsupported',
  );
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const next = await getPushStatus();
      if (!cancelled) {
        setStatus(next);
        setShowPrompt(shouldShowPushPrompt());
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const enable = useCallback(async () => {
    setBusy(true);
    setError(null);
    markPushPromptSeen();
    setShowPrompt(false);
    try {
      const next = await enableWebPush();
      setStatus(next);
      if (next === 'missing-vapid') {
        setError('Phone notifications are not available on this server.');
      } else if (next === 'denied') {
        setError('Notifications stay off until you allow them in the browser.');
      } else if (next === 'subscribed' || next === 'granted') {
        setError(null);
      }
      return next;
    } catch (e) {
      const message =
        e instanceof Error ? e.message : 'Could not enable alerts';
      setError(message);
      throw e;
    } finally {
      setBusy(false);
    }
  }, []);

  return {
    status,
    busy,
    error,
    showPrompt,
    supported: isWebPushSupported(),
    enable,
  };
}
